module.exports = window.veci;
